export const tileConfig = {
    width: 45,
    height: 45,
};

export const gameConfig = {
    tileCount: 3,
}

export const boardConfig = {
    width: 500,
    height: 500,
    padding: 5,
}